module.exports = __webpack_public_path__ + "img/repair.5b94ef82.png";